/**
 * Spel-, run- en procedurele types, plus de i18n-locale.
 */
import type { ChakraId } from './chakra.types';
import type { Kaart } from './kaart.types';

/* ------------------------------------------------------------------ */
/* i18n                                                                */
/* ------------------------------------------------------------------ */

/**
 * Actieve taal van de gebruikersinterface. Wordt bepaald uit de systeemtaal
 * van het apparaat; valt terug op `'en'` (Engels) als detectie faalt.
 * Een `Locale` is altijd een ISO-639-1 code (string) zodat extra talen
 * zonder typewijziging kunnen worden toegevoegd.
 */
export type Locale = string;

/** Talen waarvoor (minimaal) een ingebouwde UI-vertaling bestaat. */
export const ONDERSTEUNDE_TALEN = ['en', 'nl'] as const;

/** De basis-/fallbacktaal wanneer de systeemtaal onbekend is. */
export const FALLBACK_TAAL: Locale = 'en';

/* ------------------------------------------------------------------ */
/* Combo's                                                             */
/* ------------------------------------------------------------------ */

/**
 * Een chakra-combinatie die bij activatie een bonuseffect geeft.
 * `isWinconditie` is alleen waar voor de "Volledige Balans" (alle 7).
 */
export type Combo = {
  id: string;
  naam: string;
  chakras: ChakraId[];
  effect: string;
  energieBonus: number;
  kennisBonus: number;
  isWinconditie: boolean;
};

/* ------------------------------------------------------------------ */
/* Spelstatus                                                          */
/* ------------------------------------------------------------------ */

export type SpelStatus = {
  spelerDeck: Kaart[];
  hand: Kaart[];
  speelveld: Kaart[];
  aflegStapel: Kaart[];
  energiePunten: number;
  kennisScore: number;
  ronde: number;
  actieveRun: Run | null;
};

/* ------------------------------------------------------------------ */
/* Run & procedurele content                                          */
/* ------------------------------------------------------------------ */

export type Wereld = {
  id: string;
  naam: string;
  setting: string;
  sfeer: string;
  beschrijving: string;
};

export type Antagonist = {
  id: string;
  naam: string;
  tactiek: string;
  favoriteBlokkade: string;
  uniekeKaarten: Kaart[];
};

export type Personage = {
  id: string;
  naam: string;
  startKracht: string;
  uniekeKaarten: Kaart[];
  startBonus: Partial<Record<ChakraId, number>>;
};

export type Run = {
  id: string;
  wereld: Wereld;
  antagonist: Antagonist;
  personage: Personage;
  gestart: Date;
  rondes: number;
  gewonnen: boolean;
};
